import './forklift/style';
import FormStructure from './forklift/form_structure';

export default FormStructure;